import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { newSubcategoriasProductosSchema } from '@/shared';
import { useCreateSubCategorias, useUpdateSubCategorias } from '@/shared/actions/erp/compras/subcategorias-productos.actions';
import {
  CustomTextField,
  SingleFormBoxScene,
  CustomAutocomplete,
  SampleCheckbox
} from '@/shared/components/ui';
import { SubCategorias } from '@/shared/interfaces';
import { useFetchCategoryProduct } from '@/shared/actions/erp';
import { CATEGORYPRODUCT } from '@/shared/interfaces/erp/inventario';

const returnUrlSubCategorias = '/inventario/subcategoria-productos';

export interface SaveSubcategoriasInterface {
  titlePage: string;
  editSubcategorias?: SubCategorias;
}

type SaveFormData = {
  nombre: string;
  estado: boolean;
  categoria_producto: string;
};

const SaveSubcategorias: React.FC<SaveSubcategoriasInterface> = ({ titlePage, editSubcategorias }) => {


  const navigate = useNavigate();
  const [shrink, setShrink] = useState(false);

  ///* mutations
  const createSubCategoriasMutation = useCreateSubCategorias({ navigate, returnUrl: returnUrlSubCategorias });
  const updateSubCategoriasMutation = useUpdateSubCategorias({ navigate, returnUrl: returnUrlSubCategorias });

  ///* fetch data
  const { data: CategoryProductsPaging, isLoading: isLoadingCategoryProducts } = useFetchCategoryProduct({
    page_size: 600,
  });

  ///* form
  const form = useForm<SaveFormData>({
    resolver: yupResolver(newSubcategoriasProductosSchema),
    defaultValues: {
      estado: false,
    }
  });
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors, isValid },
  } = form;

  ///* handlers
  const onSave = () => {
    if (!isValid) return;

    ///* upd
    if (editSubcategorias?.id_subcategoriaproducto) {
      return updateSubCategoriasMutation.mutate({
        id: editSubcategorias.id_subcategoriaproducto,
        data: form.getValues() as any, // percent
      });
    }

    ///* create
    return createSubCategoriasMutation.mutate(form.getValues() as any);
  };
  ///*fetch
  const onChangeCategorias = (value: string) => {
    form.setValue('categoria_producto', value);
  };

  ///* effects
  useEffect(() => {
    if (editSubcategorias) {
      setShrink(true);
      reset({
        ...editSubcategorias
      } as any);
    }
  }, [editSubcategorias]);


  return (
    <SingleFormBoxScene
      titlePage={titlePage}
      onCancel={() => {
        navigate(returnUrlSubCategorias);
      }}
      onSave={handleSubmit(onSave)}
    >
      <CustomTextField
        label="Nombre"
        name="nombre"
        control={control}
        error={errors.nombre}
        helperText={errors.nombre?.message}
        shrink={shrink}
      />
      <CustomAutocomplete<CATEGORYPRODUCT>
        label="Categoria del producto"
        name="categoria_producto"
        //// options
        options={CategoryProductsPaging?.data.data || []}
        // label & search by name
        valueKey="nombre"
        actualValueKey="codigo"
        //
        defaultValue={form.getValues().categoria_producto || ''}
        optionLabelForEdit={form.getValues().categoria_producto || ''}
        isLoadingData={isLoadingCategoryProducts}
        //// validation
        control={control}
        error={errors.categoria_producto}
        helperText={errors.categoria_producto?.message}
        onChangeValue={onChangeCategorias}
      />
      {/* ====== state ====== */}
      <SampleCheckbox
        label="Estado"
        name="estado"
        control={form.control}
        defaultValue={!!form.getValues().estado}
        isState
      />
    </SingleFormBoxScene>
  );
};

export default SaveSubcategorias;
